import React from 'react';
import {replaceWithIcons} from "/src/_v2/utils/replaceWithIcons";
import {twMerge} from "tailwind-merge";

const getTh = th => {
  th = th.split(/\r?\n/);
  if(th?.length > 1){
    return `<p class="tw:subtitle4">${th[0]}</p><p class="tw:mt-1 tw:md:mt-4 tw:text-body3 tw:text-bw-500">${th[1]}</p>`
  } else {
    return `<p class="tw:subtitle4">${th[0]}</p>`
  }
}

export const EarnTable = ({data}) => {
  const {columns, rows} = data || {}

  return rows && rows?.length > 0 && (
    <div className="tw:lg:space-y-8 tw:relative tw:mb-28 tw:lg:mb-40">
      <div
        className="tw:max-lg:absolute tw:top-0 tw:left-0 tw:bottom-19 tw:bg-black-surface tw:max-lg:w-150 tw:max-md:w-125 tw:max-lg:py-16 tw:flex tw:flex-col tw:lg:grid tw:lg:grid-cols-22 tw:lg:gap-8 tw:lg:gap-22">
        {Object.values(columns).map((th, index) =>(
          <div
            className={twMerge(`tw:py-8 tw:max-md:pr-10`,
              index === 2 ? `tw:max-lg:min-h-98 tw:max-md:min-h-78` : `tw:max-lg:min-h-68 tw:max-md:min-h-58`,
              index === 1 && `tw:max-lg:min-h-40 tw:max-md:min-h-36`,
              index === 2 ? 'tw:lg:col-span-6 tw:lg:col-span-4' : 'tw:lg:col-span-5 tw:lg:col-span-3',
              index === 0 && 'tw:lg:pl-24',
              index === 6 && 'tw:pr-0',
            )}
            key={index}
            dangerouslySetInnerHTML={{__html:getTh(th)}}
          >
          </div>
        ))}
      </div>
      {rows && rows?.length > 0 && (
        <div
          className="tw:max-lg:pl-150 tw:max-md:pl-125 tw:max-lg:overflow-x-auto tw:max-md:overflow-x-auto tw:scroll-thin tw:max-lg:pb-20 tw:max-lg:pr-16 tw:max-lg:-mr-44 tw:max-md:-mr-16 tw:scrollbar-pink">
          <div className="tw:lg:space-y-8 tw:grid-cols-5 tw:max-lg:grid tw:gap-16 tw:max-lg:min-w-848">
            {rows.map((row, trIndex) => (
              <div
                className={twMerge(`tw:max-lg:py-16 tw:grid tw:lg:grid-cols-22 tw:lg:gap-8 tw:lg:gap-24 tw:rounded-2xl tw:border tw:border-white`,
                  trIndex === 0 && 'tw:bg-pink tw:border-pink tw:text-black-surface')}

                key={trIndex}>
                {Object.values(row).map((td, tdIndex) =>(
                  <div
                    key={tdIndex}
                    className={twMerge("tw:max-lg:py-8 tw:max-lg:px-20 tw:py-13 tw:tag1 tw:self-center",
                      `tw:max-lg:text-center`,
                      tdIndex === 2 ? `tw:max-lg:min-h-98 tw:max-md:min-h-78` : `tw:max-lg:min-h-68 tw:max-md:min-h-58`,
                      tdIndex === 1 && `tw:max-lg:min-h-40 tw:max-md:min-h-36`,
                      tdIndex === 2 ? 'tw:lg:col-span-6 tw:lg:col-span-4' : 'tw:lg:col-span-5 tw:lg:col-span-3',
                      tdIndex !== 0 && 'tw:text-right',
                      tdIndex === 1 && 'tw:text-center',
                      tdIndex === 0 && 'tw:pl-24',
                      tdIndex === 6 && 'tw:pr-20',
                    )}>
                    {td}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
